(() => {
  'use strict';
  if (window.vbcDoseCalculatorLoaded) return;
  window.vbcDoseCalculatorLoaded = true;
  const format = new Intl.NumberFormat('tr-TR', {maximumFractionDigits: 1});
  function calculate(calculator) {
    const input = calculator.querySelector('[data-vbc-dose]');
    if (!input) return;
    const dose = input.valueAsNumber;
    const baseDose = Number(calculator.dataset.baseDose);
    const output = Number(calculator.dataset.baseOutput);
    const outputMax = Number(calculator.dataset.maxOutput);
    const bloom = Number(calculator.dataset.bloom);
    const valid = input.validity.valid && Number.isFinite(dose) && dose > 0 && Number.isFinite(baseDose) && baseDose > 0 && Number.isFinite(output) && output > 0 && Number.isFinite(outputMax) && outputMax >= 0 && Number.isFinite(bloom) && bloom >= 0 && bloom <= output;
    input.setAttribute('aria-invalid', String(!valid));
    const values = [['[data-vbc-output]', output], ['[data-vbc-output-max]', outputMax], ['[data-vbc-bloom]', bloom]];
    values.forEach(([selector, value]) => {
      const element = calculator.querySelector(selector);
      if (element) element.textContent = valid ? format.format(dose * value / baseDose) : '—';
    });
  }
  function initialize(scope) {
    scope.querySelectorAll('[data-vbc-dose-calculator]').forEach(calculate);
  }
  document.addEventListener('input', event => {
    if (!event.target.matches('[data-vbc-dose]')) return;
    const calculator = event.target.closest('[data-vbc-dose-calculator]');
    if (calculator) calculate(calculator);
  });
  document.addEventListener('shopify:section:load', event => initialize(event.target));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document), {once: true});
  else initialize(document);
})();
